import React, { useEffect, useState } from "react";
import { Row, Col, Card, Input, Typography, Table, Tag } from "antd";
import { SearchOutlined, UserOutlined } from "@ant-design/icons";
import moment from "moment";
import axiosNew from "../../store/api/axiosNew";

const { Title } = Typography;

const RetailUserInteractionsList = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
  });

  const fetchUserInteractions = async (page = 1, limit = 10, search = "") => {
    try {
      setLoading(true);
      const token = localStorage.getItem("accessToken");

      const res = await axiosNew.get(
        "https://stageapilead.blaccdot.com/api/auth/user-interaction-list",
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { page, limit, search },
        }
      );

      setUsers(res.data?.data || []);
      setPagination({
        page: res.data?.page || page,
        limit: res.data?.limit || limit,
        total: res.data?.total || 0,
      });
    } catch (error) {
      console.error("Failed to fetch user interactions", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserInteractions(1, pagination.limit, "");
  }, []);

  const columns = [
    {
      title: "User ID",
      dataIndex: "userId",
      key: "userId",
      width: 90,
      render: (id) => id ?? "N/A",
    },
    {
      title: "User Name",
      dataIndex: "name",
      key: "name",
      width: 180,
      fixed: "left",
      render: (name) => (
        <span style={{ fontWeight: "bold", color: "#1890ff" }}>
          {name || "N/A"}
        </span>
      ),
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNo",
      key: "mobileNo",
      width: 150,
      render: (mobile) => mobile || "N/A",
    },
   {
  title: "User Category",
  dataIndex: "userCategory",
  key: "userCategory",
  width: 160,
  render: (category) => {
    if (!category) return <Tag color="blue">N/A</Tag>;

    const categoryMap = {
      realEstate: "REAL ESTATE",
    };

    const displayText = categoryMap[category] || category.toUpperCase();

    return <Tag color="blue">{displayText}</Tag>;
  },
},
    {
      title: "Status",
      dataIndex: "isRepeated",
      key: "isRepeated",
      width: 120,
      render: (isRepeated) => (
        <Tag color={isRepeated ? "orange" : "green"}>
          {isRepeated ? "REPEATED" : "NEW"}
        </Tag>
      ),
    },
    {
      title: "Submission Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (date) => (date ? moment(date).format("DD-MM-YYYY HH:mm") : "N/A"),
    },
  ];

  const handleTableChange = (paginationInfo) => {
    fetchUserInteractions(
      paginationInfo.current,
      paginationInfo.pageSize,
      searchTerm
    );
  };

  return (
    <div style={{ padding: "20px", background: "#f5f5f5", minHeight: "100vh" }}>
      {/* Header Title */}
      <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Col>
          <Title
            level={3}
            style={{ margin: 0, display: "flex", alignItems: "center", gap: 8 }}
          >
            <UserOutlined style={{ color: "#1890ff" }} />
            Retail User Interaction
          </Title>
        </Col>
      </Row>

      {/* Main Table Card */}
      <Row>
        <Col span={24}>
          <Card
            style={{ width: "100%", borderRadius: "8px" }}
            bodyStyle={{ padding: 0 }}
            title="User Form Submissions"
            extra={
              <Input
                placeholder="Search users..."
                value={searchTerm}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchTerm(value);
                  fetchUserInteractions(1, pagination.limit, value);
                }}
                prefix={<SearchOutlined style={{ color: "#888" }} />}
                style={{ width: 300 }}
              />
            }
          >
            <Table
              rowKey={(record) => record._id || record.userId}
              columns={columns}
              dataSource={users}
              loading={loading}
              scroll={{ x: "max-content" }}
              pagination={{
                current: pagination.page,
                pageSize: pagination.limit,
                total: pagination.total,
                showTotal: (total) => `Total ${total} user submissions`,
              }}
              onChange={handleTableChange}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RetailUserInteractionsList;